import { IAvailableSeasonTicket } from '@r1-frontend/api-domru/api-season-ticket/v1/season-ticket/dto/ResponseDto';

import { IAction } from '~/src/store';

import { ETicketPayment } from './index';

export type TSetSeasonTicket = IAction<ETicketPayment.SET_SEASON_TICKET, IAvailableSeasonTicket | undefined>

const setSeasonTicket = (ticket: IAvailableSeasonTicket): TSetSeasonTicket => ({
    type: ETicketPayment.SET_SEASON_TICKET,
    payload: ticket,
});

export default setSeasonTicket;
